import { useTraduction } from "../../Contexte/TraductionContext";

function HomeNumber() {
    const { contentAccueil } = useTraduction()
    
    return <>
        <section id="HomeNumber">

    <div className="container">

        <ul>
            <li>
                <p className="Number">1890</p>
                <p className="NumberText">{contentAccueil.ChiffreAge}</p>
            </li>
            <span className="VerticalLine"></span>
            <li>
                <p className="Number">60</p>
                <p className="NumberText">{contentAccueil.ChiffreExperience}</p>
            </li>
            <span className="VerticalLine"></span>
            <li>
                <p className="Number">2K</p>
                <p className="NumberText">{contentAccueil.ChiffreClient}</p>
            </li>
            <span className="VerticalLine"></span>
            <li>
                <p className="Number">+15K</p>
                <p className="NumberText">{contentAccueil.ChiffreConvoyeur}</p>
            </li>
            <span className="VerticalLine"></span> 
            <li>
                <p className="Number">100%</p>
                <p className="NumberText">{contentAccueil.ChiffreQualite}</p>
            </li>
            
            
            
        </ul>

    </div>

</section>

    
    </>
}

export default HomeNumber